import React, { forwardRef } from 'react';
import BaseButton from './BaseButton';

const ResetButton = forwardRef(({ title = 'Reset', ...props }, ref) => (
  <BaseButton
    ref={ref}
    id='reset-button'
    className='reset-button'
    icon='reset'
    tooltip={title}
    {...props}
  />
));

export default ResetButton;
